const downloadFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const downloadQRCodeAsPNG = (qrCode: string, filename = 'qr-code.png'): void => {
  const img = new Image()
  img.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.width = img.width || 300
    canvas.height = img.height || 300
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0)
      canvas.toBlob((blob) => {
        if (blob) {
          downloadFile(blob, filename)
        }
      }, 'image/png')
    }
  }
  img.src = qrCode
}

export const downloadQRCodeAsSVG = (qrCode: string, filename = 'qr-code.svg'): void => {
  const base64Data = qrCode.split(',')[1]
  const svgContent = atob(base64Data)
  const blob = new Blob([svgContent], { type: 'image/svg+xml' })
  downloadFile(blob, filename)
}
